import { norm } from "./entities";

// Bot behavior: each bot has a personality weighting objects vs hunting vs fleeing.
const PERSONAS = [
  { name: "farmer", objW: 1.0, huntW: 0.3, fear: 1.3 },
  { name: "hunter", objW: 0.5, huntW: 1.0, fear: 0.8 },
  { name: "balanced", objW: 0.8, huntW: 0.7, fear: 1.0 },
  { name: "aggressive", objW: 0.4, huntW: 1.2, fear: 0.5 },
];

export function initBot(bot) {
  bot.persona = PERSONAS[Math.floor(Math.random() * PERSONAS.length)];
  bot._retarget = 0;
  bot._target = null;
  bot._wander = Math.random() * Math.PI * 2;
}

export function updateBot(bot, dt, world, vehicles, grid, cell) {
  bot._retarget -= dt;
  const p = bot.persona;

  // Threat check: any nearby vehicle much stronger?
  let flee = null, fleeD = 1e9;
  let prey = null, preyD = 1e9;
  for (const v of vehicles) {
    if (v === bot || !v.alive) continue;
    const d = Math.hypot(v.x - bot.x, v.y - bot.y);
    if (d > 700) continue;
    if (v.smashPower > bot.smashPower * 1.4 && d < 380 * p.fear) {
      if (d < fleeD) { fleeD = d; flee = v; }
    } else if (v.smashPower <= bot.smashPower && d < preyD) {
      preyD = d; prey = v;
    }
  }

  let goal = null;
  if (flee) {
    // steer away
    const ang = Math.atan2(bot.y - flee.y, bot.x - flee.x);
    goal = { x: bot.x + Math.cos(ang) * 300, y: bot.y + Math.sin(ang) * 300, boost: fleeD < 200 };
  } else if (prey && Math.random() < p.huntW && preyD < 500) {
    goal = { x: prey.x, y: prey.y, boost: preyD > 250 };
  } else {
    // find nearest smashable obstacle
    if (bot._retarget <= 0 || !bot._target || bot._target.dead) {
      bot._retarget = 0.8 + Math.random();
      bot._target = nearestObstacle(bot, grid, cell);
      if (!bot._target) { bot._wander = Math.random() * Math.PI * 2; }
    }
    if (bot._target && !bot._target.dead) {
      goal = { x: bot._target.x, y: bot._target.y, boost: false };
    } else {
      goal = { x: bot.x + Math.cos(bot._wander) * 300, y: bot.y + Math.sin(bot._wander) * 300, boost: false };
    }
  }
  // keep away from edges
  const margin = 260;
  if (bot.x < margin || bot.x > world.w - margin || bot.y < margin || bot.y > world.h - margin) {
    goal = { x: world.w / 2, y: world.h / 2, boost: false };
  }
  const ta = Math.atan2(goal.y - bot.y, goal.x - bot.x);
  bot.control.targetAngle = ta;
  bot.control.throttle = 1;
  bot.control.boost = goal.boost && bot.boostEnergy > 20;
  bot.control.steer = 0;
}

function nearestObstacle(bot, grid, cell) {
  const cx = Math.floor(bot.x / cell), cy = Math.floor(bot.y / cell);
  let best = null, bd = 1e9;
  for (let ix = -3; ix <= 3; ix++) for (let iy = -3; iy <= 3; iy++) {
    const arr = grid.get(`${cx + ix},${cy + iy}`);
    if (!arr) continue;
    for (const o of arr) {
      if (o.dead || bot.smashPower < o.def.tough) continue;
      const d = (o.x - bot.x) ** 2 + (o.y - bot.y) ** 2;
      if (d < bd) { bd = d; best = o; }
    }
  }
  return best;
}
